import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { IEvent } from '../../classes/event';
import { ICalendarAppBaseText } from '../../classes/buytickets-text';
import { connect } from 'react-redux';
import ListEventView from '../../views/buy-tickets-event.view';
import { IBuyTicketsAppState } from '../../redux-state';
import { Modal } from '../../../../static/javascript/modules/modal';
import { nodeListToArray } from '../../../../static/javascript/helpers/nodeListToArray'; 


interface IListEventExternalProps {
    event: IEvent;
    cssClass: string;
}

interface StateToProps {
    text: ICalendarAppBaseText;
}

export type ListEventProps = IListEventExternalProps & StateToProps;


export class ListEventBase extends React.Component<ListEventProps, StateToProps> {
    constructor(props: ListEventProps) {
        super(props);
    }
    componentDidMount() {
        // Modals Init
        let modals = nodeListToArray((ReactDOM.findDOMNode(this) as HTMLElement).querySelectorAll(`[data-modal]`));
        const allModals = {};
        window["allModalRefs"] = allModals;
        modals.forEach(modal => {
            const modalRef = new Modal(modal);
            allModals[(modal as HTMLElement).id] = modalRef;
        })
    }
    render() {
        return (
            <ListEventView {...this.props} />
        )
    }
}

function mapStateToProps(state: IBuyTicketsAppState): StateToProps {
    return {
        text: state.calendarText
    }
}

export default connect(mapStateToProps)(ListEventBase);